var exports = {
  "kL": "EmojiTooltipContent.module__container___T1I0am",
  "Zg": "EmojiTooltipContent.module__emoji___T1I0am",
  "FS": "EmojiTooltipContent.module__textContainer___T1I0am",
  "Lq": "EmojiTooltipContent.module__loading___T1I0am",
  "W$": "EmojiTooltipContent.module__subtext___T1I0am",
  "vW": "EmojiTooltipContent.module__inner___T1I0am",
};

module.exports = exports;
